import { IconButton } from "@mui/material";
import { Flex, message, Popconfirm } from "antd";
import PhoneIcon from "@mui/icons-material/Phone";
import HistoryIcon from "@mui/icons-material/History";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { set_OrganizationID } from "../features/ConfigSlice";
import { API } from "../config/auth";

const Sidebar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [messageApi, contextHolder] = message.useMessage();

  const logout = async () => {
    const response = await API.post("/organization/logout");

    console.log(response);

    if (response?.status === 200) {
      messageApi.success("Logged out successfully!!");
      window.localStorage.clear();

      dispatch(set_OrganizationID(""));

      navigate("/login");
    }
  };

  return (
    <div className="sidebar">
      {contextHolder}

      <Flex vertical gap={16}>
        <IconButton
          onClick={() => {
            navigate("/jas");
          }}
        >
          <PhoneIcon />
        </IconButton>

        <IconButton
          onClick={() => {
            navigate("/jas/history");
          }}
        >
          <HistoryIcon />
        </IconButton>
      </Flex>

      <Popconfirm
        title="Do you want to logout?"
        okText="Yes"
        cancelText="No"
        onConfirm={logout}
      >
        <IconButton>
          <LogoutIcon />
        </IconButton>
      </Popconfirm>
    </div>
  );
};

export default Sidebar;
